module.exports = __webpack_public_path__ + "img/YMESicon3.51c3a922.png";